import { useState, useEffect } from "react";
import LotsTable from "./LotsTable";
import Cookies from "js-cookie";
import { getModel } from "../../../../API/modelList";
import { useNavigate } from "react-router-dom";

const ModelConfiguration = () => {
  const [configKey, setConfigKey] = useState(null);
  const navigate = useNavigate();
  const configkeyset = Cookies.get("configkey");

   // Fonction qui sélectionne automatiquement un modèle et redirige l'utilisateur en fonction
  const autoSelectElement = async () => {
    const idToken = Cookies.get("Token");
    try {
      const modelData = await getModel(idToken);
      if (modelData.length === 1) {
        const model = modelData[0];
        const modelComponent = model.ModelComponent;

        if (!modelComponent) {
          setConfigKey("DefaultLots");
          Cookies.set("configkey", "DefaultLots");
          navigate(`/User/DefaultLots`);
          return;
        }

        const newConfigKey =
          modelComponent.charAt(0).toUpperCase() +
          modelComponent.slice(1) +
          "Lots";

        setConfigKey(newConfigKey);
        Cookies.set("configkey", newConfigKey);
        navigate(`/User/${newConfigKey}`);
      } else {
        setConfigKey("DefaultLots");
        Cookies.set("configkey", "DefaultLots");
        navigate(`/User/DefaultLots`);
      }
    } catch (error) {
      console.error("Erreur dans autoSelectElement :", error);
      setConfigKey("DefaultLots");
      Cookies.set("configkey", "DefaultLots");
      navigate(`/User/DefaultLots`);
    }
  };

  // Effet qui initialise le configKey en vérifiant les cookies ou en sélectionnant automatiquement
  useEffect(() => {
    if (!configkeyset) {
      autoSelectElement();
    } else {
      setConfigKey(configkeyset);
    }
  }, []);

  if (!configKey) {
    return <div>Chargement...</div>;
  }

  return (
    <>
      <LotsTable configKey={configKey} /> 
    </>
  );
};

export default ModelConfiguration;
